import script from "./sub-master.vue?vue&type=script&setup=true&lang=js"
export * from "./sub-master.vue?vue&type=script&setup=true&lang=js"

import "./sub-master.vue?vue&type=style&index=0&id=116e2af4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-116e2af4"]])

export default __exports__